export default __webpack_public_path__ + "static/media/pokemon_steel.f8861bd7.png";